module.exports = __webpack_public_path__ + "img/bh.cde3b127.svg";